import React, { Fragment, useEffect, useState, useCallback } from 'react'

import * as styles from './index.module.css'

import Hero from '../hero'
import Default from '../DefaultPageBlock'
import ProductHighlight from '../ProductHighlight'
import OusterInAction from '../OusterInAction'
import LidarArchitecture from '../LidarArchitecture'
import SensorHighlight from '../SensorHighlight'
import WorkWithUs from '../WorkWithUs'
import OsHero from '../OsHero'
import Os0Hero from '../Os0Hero'
import OsFeatures from '../OsFeatures'
import OsGeneric from '../OsGeneric'
import OsBackground from '../OsBackground'
import OsSpecifications from '../OsSpecifications'
import Os0Specifications from '../Os0Specifications'
import Os1Pricing from '../Os1Pricing'
import Os2Pricing from '../Os2Pricing'
import MainBlackHeader from '../MainBlackHeader'
import TtsDescription from '../TtsDescription'
import TtsForm from '../TtsForm'
import DocumentationResources from '../DocumentationResources'
import SensorUpdateProcess from '../SensorUpdateProcess'
import ChangeLog from '../ChangeLog'
import CenteredText from '../CenteredText'
import DistributorRegion from '../DistribitorRegion'
import CareerIntro from '../CareerIntro'
import CareerPros from '../CareerPros'
import CareerVideo from '../CareerVideo'
import CareerAboutUs from '../CareerAboutUs'
import CareerInfoGraphic from '../CareerInfoGraphic'
import AboutOuster from '../AboutOuster'
import AboutTeam from '../AboutTeam'
import Leadership from '../Leadership'
import Investors from '../Investors'
import AboutUsCarousal from '../AboutUsCarousal'
import FullWidthVideo from '../FullWidthVideo'
import FullWidthVideoCallout from '../FullWidthVideoCallout'
import CompanyContactForm from '../CompanyContactForm'
import CompanyContactSection from '../CompanyContactSection'
import CompanyMoto from '../CompanyMoto'
import OS2LongRangeLidar from '../OS2LongRangeLidar'
import RawHTML from '../RawHTML'
import Error404 from '../404'
import SEO from '../SEO'
import PanoramicImage from '../PanoramicImage'
import SimpleCallout from '../SimpleCallout'
import CustomersInSecurity from '../CustomersInSecurity'
import ShortHero from '../shortHero'
import BasicExternalViz from '../BasicExternalViz'
import ExternalViz from '../ExternalViz'
import ImageSlideShow from '../ImageSlideShow'
import LogoCollection from '../LogoCollection'
import PopupInfoImages from '../PopupInfoImages'
import DarkIframeContainer from '../DarkIframeContainer'
import TwoColumnText from '../TwoColumnText'
import PanoramicImageLight from '../PanoramicImageLight'
import IconInfoList from '../IconInfoList'
import BackgroundImageCallout from '../BackgroundImageCallout'
import FeatureVideoPlayer from '../FeatureVideoPlayer'
import ProductsHero from '../productsHero'
import CareerBoard from '../CareerBoard'
import LearnMoreGrid from '../LearnMoreGrid'
import CustomerQuote from '../CustomerQuote'
import AlternateImageText from '../AlternateImageText'
import AlternateFullImageText from '../AlternateFullImageText'
import CustomerUseCases from '../CustomerUseCases'
import LidarAccessories from '../LidarAccessories'
import Os0Features from '../Os0Features'
import Os0Pricing from '../Os0Pricing'
import ProductsShowCase from '../ProductsShowCase'
import AnimatedIntroImage from '../AnimatedIntroImage'
import FAQ from '../FAQ'
import GenericTextWithTitle from '../GenericTextWithTitle'
import ProductComparison from '../ProductComparison'
import Spacer from '../Spacer'
import MarkdownTextFullPage from '../MarkdownTextFullPage'
import FullWidthCalloutWithImage from '../FullWidthCalloutWithImage'
import HomePageHero from '../HomePageHero'
import BasicImage from '../BasicImage'
import TextWithCTA from '../TextWithCTA'
import TwoThirdsCallout from '../TwoThirdsCallout'
import BigNumbers from '../BigNumbers'
import LogoImages from '../LogoImages'
import ProductDetails from '../ProductDetails'
import ContentCards from '../ContentCards'
import ContactFollowSection from '../ContactFollowSection'
import CTAListWithTitlesAndImages from '../CTAListWithTitlesAndImages'
import SensorTechnology from '../SensorTechnology'
import Subnav from '../Subnav'
import BasicImageWithText from '../BasicImageWithText'
import Event from '../Event'
import ImageCarousel from '../ImageCarousel'
import ImageComparisonSlider from '../ImageComparisonSlider'
import PartnerDetails from '../PartnerDetails'
import SortableComponentElements from '../SortableComponentElements'
import FeaturedEvent from '../FeaturedEvent'
import FiftyFiftyWithTitle from '../FiftyFiftyWithTitle'
import SevenColumnImage from '../SevenColumnImage'
import IPHero from '../IPHero'
import Value from '../Value'
import Quote from '../Quote'
import CardsWithIcons from '../CardsWithIcons'
import ScrollingCards from '../ScrollingCards'
import FourAcrossSquares from '../FourAcrossSquares'
import MarketoForm from '../MarketoForm'

import useWindowSize from '../../hooks/useWindowSize'

const Page = ({ data, sortableData, sortableFieldItems }) => {
  const [prevScrollPos, setPrevScrollPos] = useState(0)
  const [scrollingUp, setScrollingUp] = useState(false)
  const size = useWindowSize()

  const handleScroll = useCallback(() => {
    const currentScrollPos = window.pageYOffset
    setScrollingUp(prevScrollPos > currentScrollPos)
    setPrevScrollPos(currentScrollPos)
  }, [prevScrollPos])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return function cleanup() {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  const checkNav = (scrollingUp, size, handleScroll) => {
    const hiddenNav = document.querySelector('.hiddenNavigation')
    const subNavCont = document.querySelector('.subNavCont')
    const navCont = document.querySelector('nav')
    if (subNavCont && navCont) {
      if (scrollingUp) {
        subNavCont.style.top = `${navCont.getBoundingClientRect().height}px`
      } else {
        if (hiddenNav) {
          subNavCont.style.top = `0`
        } else {
          subNavCont.style.top = `${navCont.getBoundingClientRect().height}px`
        }
      }
    }
  }

  useEffect(() => {
    checkNav(scrollingUp, size.width, handleScroll)
  }, [scrollingUp, size.width, handleScroll])

  useEffect(() => {
    setTimeout(checkNav(), 500)
  }, [])

  const getWrappedComponent = (data, idx, nodeLocale) => {
    const stickyClass = data.type === 'subnav' ? styles.sticky : ''
    const adjustForNavClass = scrollingUp ? `${styles.adjustForNav}` : ''
    const subNavAdjust = data.type === 'subnav' ? `subNavCont` : ''
    return (
      <div
        id={data.anchorID}
        key={idx}
        className={`${stickyClass} ${adjustForNavClass} ${subNavAdjust}`}
      >
        {getComponent(data, nodeLocale)}
      </div>
    )
  }

  const getComponent = (data, nodeLocale) => {
    switch (data.type) {
      case 'hero':
        return <Hero {...data} />

      case 'shortHero':
        return <ShortHero {...data} />

      case 'homePageHero':
        return <HomePageHero {...data} />

      case 'basicExternalViz':
        return <BasicExternalViz {...data} />

      case 'productHighlight':
        return <ProductHighlight {...data} />

      case 'ousterInAction':
        return <OusterInAction {...data} nodeLocale={nodeLocale} />

      case 'lidarArchitecture':
        return <LidarArchitecture {...data} />

      case 'sensorHighlight':
        return <SensorHighlight {...data} />

      case 'workWithUs':
        return <WorkWithUs {...data} />

      case 'panoramicImage':
        return <PanoramicImage {...data} />

      case 'logoCollection':
        return <LogoCollection {...data} />

      case 'animatedIntroImage':
        return <AnimatedIntroImage {...data} />

      case 'popupInfoImages':
        return <PopupInfoImages {...data} />

      case 'FAQ':
        return <FAQ {...data} />

      case 'darkIframeContainer':
        return <DarkIframeContainer {...data} />

      case 'twoColumnText':
        return <TwoColumnText {...data} />

      case 'markdownTextFullPage':
        return <MarkdownTextFullPage {...data} />

      case 'panoramicImageLight':
        return <PanoramicImageLight {...data} />

      case 'learnMoreGrid':
        return <LearnMoreGrid {...data} nodeLocale={nodeLocale} />

      case 'iconInfoList':
        return <IconInfoList {...data} />

      case 'backgroundImageCallout':
        return <BackgroundImageCallout {...data} />

      case 'BackgroundImageCallout':
        return <BackgroundImageCallout {...data} />

      case 'simpleCallout':
        return <SimpleCallout {...data} />

      case 'featureVideoPlayer':
        return <FeatureVideoPlayer {...data} nodeLocale={nodeLocale} />

      case 'customersInSecurity':
        return <CustomersInSecurity {...data} />

      case 'osHero':
        return <OsHero {...data} />

      case 'os0Hero':
        return <Os0Hero {...data} />

      case 'osFeatures':
        return <OsFeatures {...data} />

      case 'osGeneric':
        return <OsGeneric {...data} />

      case 'osBackground':
        return <OsBackground {...data} />

      case 'osSpecifications':
        return <OsSpecifications {...data} />

      case 'os0Specifications':
        return <Os0Specifications {...data} />

      case 'os1Pricing':
        return <Os1Pricing {...data} />

      case 'os2Pricing':
        return <Os2Pricing {...data} />

      case 'mainBlackHeader':
        return <MainBlackHeader {...data} />

      case 'ttsDescription':
        return <TtsDescription {...data} />

      case 'ttsForm':
        return <TtsForm {...data} />

      case 'documentationResources':
        return <DocumentationResources {...data} />

      case 'sensorUpdateProc':
        return <SensorUpdateProcess {...data} />

      case 'changeLog':
        return <ChangeLog {...data} />

      case 'centeredText':
      case 'distributorHeading':
        return <CenteredText {...data} />

      case 'distributorRegion':
        return <DistributorRegion {...data} />

      case 'careerIntro':
        return <CareerIntro {...data} />

      case 'careerPros':
        return <CareerPros {...data} />

      case 'careerVideo':
        return <CareerVideo {...data} nodeLocale={nodeLocale} />

      case 'careerAboutUs':
        return <CareerAboutUs {...data} />

      case 'careerInfoGraphic':
        return <CareerInfoGraphic {...data} />

      case 'careerOpenings':
        return <CareerBoard {...data} nodeLocale={nodeLocale} />

      case 'aboutOuster':
        return <AboutOuster {...data} />

      case 'aboutTeam':
        return <AboutTeam {...data} />

      case 'leadership':
        return <Leadership {...data} />

      case 'aboutInvestors':
        return <Investors {...data} />

      case 'aboutUsCarousal':
        return <AboutUsCarousal {...data} />

      case 'fullWidthVideo':
        return <FullWidthVideo {...data} nodeLocale={nodeLocale} />

      case 'fullWidthVideoCallout':
        return <FullWidthVideoCallout {...data} nodeLocale={nodeLocale} />

      case 'fullWidthCalloutWithImage':
        return <FullWidthCalloutWithImage {...data} />

      case 'companyContactForm':
        return <CompanyContactForm {...data} />

      case 'companyContactSection':
        return <CompanyContactSection {...data} />

      case 'companyMoto':
        return <CompanyMoto {...data} />

      case 'os2LongRangeLidar':
        return <OS2LongRangeLidar {...data} />

      case 'rawHTML':
        return <RawHTML {...data} />

      case 'careerBoard':
        return <CareerBoard {...data} />

      case 'error404Content':
        return <Error404 {...data} />

      case 'imageSlideShow':
        return <ImageSlideShow {...data} />

      case 'customerQuote':
        return <CustomerQuote {...data} nodeLocale={nodeLocale} />

      case 'alternateImageText':
        return <AlternateImageText {...data} />

      case 'alternateFullImageText':
        return <AlternateFullImageText {...data} />

      case 'customerUseCases':
        return <CustomerUseCases {...data} />

      case 'lidarAccessories':
        return <LidarAccessories {...data} />

      case 'os0Features':
        return <Os0Features {...data} />

      case 'os0Pricing':
        return <Os0Pricing {...data} />

      case 'externalViz':
        return <ExternalViz {...data} />

      case 'productsHero':
        return <ProductsHero {...data} />

      case 'productsShowCase':
        return <ProductsShowCase {...data} />

      case 'genericTextWithTitle':
        return <GenericTextWithTitle {...data} />

      case 'productComparison':
        return <ProductComparison {...data} />

      case 'spacer':
        return <Spacer {...data} />

      case 'basicImage':
        return <BasicImage {...data} />

      case 'textWithCta':
        return <TextWithCTA {...data} />

      case 'productDetails':
        return <ProductDetails {...data} nodeLocale={nodeLocale} />

      case 'twoThirdsCallout':
        return <TwoThirdsCallout {...data} />

      case 'bigNumbers':
        return <BigNumbers {...data} />

      case 'logoImages':
        return <LogoImages {...data} />

      case 'featuredEvent':
        return <FeaturedEvent {...data} />

      case 'sortableComponent': {
        return (
          <PartnerDetails
            {...data}
            sortableData={sortableData}
            sortableFieldItems={sortableFieldItems}
            nodeLocale={nodeLocale}
          />
        )
      }

      case 'contentCards':
        return <ContentCards {...data} />

      case 'sortableComponentElements':
        return (
          <SortableComponentElements
            {...data}
            sortableData={sortableData}
            sortableFieldItems={sortableFieldItems}
            nodeLocale={nodeLocale}
          />
        )

      case 'imageComparisonSlider':
        return <ImageComparisonSlider {...data} />

      case 'event':
        return <Event {...data} />

      case 'contactFollowSection':
        return <ContactFollowSection {...data} />

      case 'sensorTechnology':
        return <SensorTechnology {...data} />

      case 'subnav':
        return <Subnav {...data} />

      case 'ctaListWithTitlesAndImages':
        return <CTAListWithTitlesAndImages {...data} />

      case 'imageCarousel':
        return <ImageCarousel {...data} />

      case 'basicImageWithText':
        return <BasicImageWithText {...data} />

      case 'fiftyFiftyWithTitle':
        return <FiftyFiftyWithTitle {...data} />

      case 'sevenColumnImage':
        return <SevenColumnImage {...data} />

      case 'ipHero':
        return <IPHero {...data} />

      case 'value':
        return <Value {...data} />

      case 'quote':
        return <Quote {...data} nodeLocale={nodeLocale} />

      case 'cardsWithIcons':
        return <CardsWithIcons {...data} />

      case 'scrollingCards':
        return <ScrollingCards {...data} />

      case 'fourAcrossSquares':
        return <FourAcrossSquares {...data} />

      case 'marketoForm':
        return <MarketoForm {...data} />

      default:
        return <Default {...data} />
    }
  }

  const nodeLocale = data.node_locale.toLowerCase()
  const blocks = data.blocks.filter((block) => block.blockVisibility !== true)

  return (
    <div className={styles.container}>
      <SEO {...data} type="page" />
      <Fragment>
        {blocks.map((block, idx) =>
          getWrappedComponent(block, idx, nodeLocale)
        )}
      </Fragment>
    </div>
  )
}

export default Page
